const events = [
{
    title: "Wedding Ceremony",
    start_time: 1759001400,
    end_time: 1759003200,
    location: "Main Stage",
    description: "Join us for a heartfelt wedding ceremony where the couple will exchange vows and rings, surrounded by their loved ones. This special occasion will feature meaningful traditions and touching moments, celebrating their commitment and the beginning of their journey together."
},
{
    title: "Tea Ceremony",
    start_time: 1759003200,
    end_time: 1759005000,
    location: "In the Back of the Woods",
    description: `Chinese wedding tea ceremony is a cherished tradition where the bride and groom serve tea to their parents and relatives.
It serves as a heartfelt gesture of respect and a meaningful way for the couple to thank their families—especially their parents—on their wedding day.

It’s traditionally attended by both the bride’s and groom’s families, including immediate and extended relatives.
Occasionally, members of the wedding party—such as bridesmaids and groomsmen—as well as close friends, may also be invited to participate in the ceremony.

**The Order of the Tea Ceremony:**
Customs may vary slightly by region, but in general, basic tea ceremony etiquette should be followed consistently.
Traditionally, the ceremony begins with serving tea to:
- Groom’s parents, followed by his grandparents.
- Bride’s parents, followed by her grandparents.
- Groom’s extended family (uncles, aunts, etc.), followed by the bride’s extended family in the same order.
- Cousins and friends are served last.

**Ceremony Etiquette:**  
During the ceremony, the groom and bride kneel on their right knee in front of their parents and grandparents while offering tea, as a sign of respect.`
    }, {
    title: "Cocktail Hour",
    start_time: 1759003200,
    end_time: 1759010400,
    location: "Main Reception Area",
    description: "Cocktail Hour"
}, {
    title: "Dinner",
    start_time: 1759010400,
    end_time: 1759017600,
    location: "Buffet Area",
    description: "dinner"
}, {
    title: "Dancing",
    start_time: 1759017600,
    end_time: 1759026600,
    location: "Buffet Area",
    description: "Join us in celebrating the first dance, and a night of fun!"
}]

export default events